export default "__VITE_ASSET__DoHvO9CI__"